<script>
    import { Container, List } from '@/components'

    const items = [
        'Сотрудники не понимают, у кого запрашивать справку или расчёт,<br/> поэтому отвлекают коллег, руководителей, HR-специалистов',
        'HR-специалисты собирают заявления по разным каналам<br/> и оформляют много однотипных документов',
        'Руководители не имеют доступа к актуальному графику отпусков<br/> и не видят, что отпуска или отгулы сотрудников пересекаются',
        'Всем приходится долго ждать ответа почте, путаться в разных<br/> мессенджерах, созваниваться или даже встречаться лично'
    ]
</script>

<Container>
    <div class="wrapper">
        <div class="problems">
            <h2 class="title">Возможно, вам знакомы<br/> 
            и эти сложности с кадровым документооборотом:</h2>

            <div class="list">
                <List {items} circleColor="#F3954A" />
            </div>
        </div>

        <div class="big-brand-wrapper" style="margin-top: 90px;">
            <div class="big-brand">
                Employee<br/>
                <span>Gate</span>
            </div>
        </div>
    </div>
</Container>

<style lang="scss">
    .wrapper {
        display: flex;

        .problems {
            max-width: 695px;

            .title {
                line-height: 60px;
            }

            .list {
                margin-top: 40px;
            }
        }

        .big-brand-wrapper {
            flex: 1;
            position: relative;
            
            .big-brand {
                position: absolute;
                top: 0;
                left: 0;

                font-weight: 900;
                font-size: 187px;
                line-height: 161px;
                color: #EEEEEE;

                span {
                    color: #fcd9c3;
                }
            }
        }
    }

    @media (max-width: 834px) {
        .wrapper {
            .problems {
                max-width: 100%;
                padding-right: 56px;
            }
        }
    }

    @media (max-width: 834px) {
        .wrapper {
            padding-right: 0;
        }

        .list {
            padding-left: 20px;
        }
    }
</style>